var determineCheckedAnswer = function (_a) {
    var currentQuestion = _a.currentQuestion, currentQuestionAnswer = _a.currentQuestionAnswer;
    return ((currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.id) === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id) &&
        (currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[0]));
};
export default determineCheckedAnswer;
//# sourceMappingURL=determineCheckedAnswer.js.map